import React from 'react'
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import { Col, Container, Row } from 'react-bootstrap';
import '../../../Assets/css/webDevelopmentDesign.css'


const PowerOfAiFaq = () => {
      const [expanded, setExpanded] = React.useState("panel1");
    
      const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
      };
  return (
    <div>
         <div className="bw_faq_section powered_ai_faq_section">
                  <Container className="bw_custome_container">
                    <Row className="w-100 m-auto">
                      <Col>
                        <h2 className='Power_AI_headings' style={{color:"#3D63C3"}}>
                          Frequently Asked Questions
                        </h2>
                      </Col>
                    </Row>
                    <Row className="w-100 m-auto">
                      <Col className="px-md-0">
                        <div
                          className="bw_wdd_faq_accordian"
                        >
                          <Accordion
                            expanded={expanded === "panel1"}
                            onChange={handleChange("panel1")}
                          >
                            <AccordionSummary
                              expandIcon={
                                expanded === "panel1" ? (
                                  <AiOutlineMinus />
                                ) : (
                                  <AiOutlinePlus />
                                )
                              }
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <Typography className="bw_accordian_heading">
                                {/* <h3>  */}
                                    What is the main benefit of using AI for jewelry product descriptions? 
                                    {/* </h3> */}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails className="border-top">
                              <Typography className="bw_accordian_ans">
                              AI-powered tools instantly generate unique, SEO-friendly product descriptions that help your jewelry stand out, improve search rankings, and boost sales-saving you time and effort compared to manual writing.
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion
                            expanded={expanded === "panel2"}
                            onChange={handleChange("panel2")}
                            defaultExpanded={true}
                          >
                            <AccordionSummary
                              expandIcon={
                                expanded === "panel2" ? (
                                  <AiOutlineMinus />
                                ) : (
                                  <AiOutlinePlus />
                                )
                              }
                              aria-controls="panel2a-content"
                              id="panel2a-header"
                            >
                              <Typography className="bw_accordian_heading">
                                {/* <h3> */}
                                      How to use AI to generate descriptions?
                                       {/* </h3> */}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails className="border-top">
                              <Typography className="bw_accordian_ans">
                             The process is user-friendly: upload an image, provide a product name, and let the AI handle the rest.  
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion
                            expanded={expanded === "panel3"}
                            onChange={handleChange("panel3")}
                            defaultExpanded={true}
                          >
                            <AccordionSummary
                              expandIcon={
                                expanded === "panel3" ? (
                                  <AiOutlineMinus />
                                ) : (
                                  <AiOutlinePlus />
                                )
                              }
                              aria-controls="panel3a-content"
                              id="panel3a-header"
                            >
                              <Typography className="bw_accordian_heading">
                                {/* <h3>  */}
                                    What is the main advantage of AI? 
                                    {/* </h3> */}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails className="border-top">
                              <Typography className="bw_accordian_ans">
                               AI speeds up task execution, handles complex processes affordably, and runs 24/7 without downtime.
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion
                            expanded={expanded === "panel4"}
                            onChange={handleChange("panel4")}
                            defaultExpanded={true}
                          >
                            <AccordionSummary
                              expandIcon={
                                expanded === "panel4" ? (
                                  <AiOutlineMinus />
                                ) : (
                                  <AiOutlinePlus />
                                )
                              }
                              aria-controls="panel4a-content"
                              id="panel4a-header"
                            >
                              <Typography className="bw_accordian_heading">
                                {/* <h3> */}
                                    Can the AI handle different styles or types of jewelry?
                                     {/* </h3> */}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails className="border-top">
                              <Typography className="bw_accordian_ans">
                              Yes, AI tools are versatile and can generate descriptions for various jewelry types (rings, necklaces, earrings, etc.) and styles (modern, vintage, luxury, etc.), tailored to your specifications.
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </div>
    </div>
  )
}

export default PowerOfAiFaq